module.exports = __webpack_public_path__ + "static/media/1997_Population_totalRate.a22e2d4f.png";